import { NavLink } from 'react-router-dom';

import { reports } from './consts';
import useTranslation from '../../customHooks/translate';

export const ReportsMain = () => {
  const translation = useTranslation();

  return (
    <div className="grid grid-cols-1 gap-[8px] p-[16px] sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {reports(translation)?.map((report, index) => (
        <NavLink key={index} to={report?.path}>
          <div className="flex h-auto flex-row-reverse items-center justify-between gap-[10px] rounded-[4px] bg-[#F5F7F9] p-[20px] shadow-sm transition-all duration-200 hover:-translate-y-1 hover:bg-[#E9EDF1] hover:shadow-md sm:h-[190px] sm:flex-col sm:items-start">
            <img
              className="h-[40px] w-[40px]"
              src={`/assets/${report.image}.svg`}
              alt={report?.label}
            />
            <p className="text-[20px] font-medium text-[#1D1D1D]">
              {report?.label}
            </p>
          </div>
        </NavLink>
      ))}
    </div>
  );
};
